import { $hasFeature } from '@/core/utils/VueAcl'

const UNMET_CONDITIONS_SHAPE = {
  unmetConditionAttributes: [],
  unmetConditionAttributesNoFallback: [],
  metConditionStatements: [],
  unmetConditionStatementsWithFallback: [],
  unmetConditionStatementsNoFallback: []
}

/**
 * Normalises the `unmetConditions` payload returned by the preview endpoint
 * into a stable shape with array fields, so consumers can call `.includes()`
 * on any field without null/shape checks. Channels that don't run dynamic
 * condition evaluation return `[]` (or omit fields), which would otherwise
 * crash the sidebar's tooltip/highlight logic.
 *
 * @param {*} unmetConditions
 * @returns {Object}
 */
export function normaliseUnmetConditions(unmetConditions) {
  const result = { ...UNMET_CONDITIONS_SHAPE }
  if (unmetConditions && typeof unmetConditions === 'object') {
    Object.keys(UNMET_CONDITIONS_SHAPE).forEach(key => {
      if (Array.isArray(unmetConditions[key])) {
        result[key] = unmetConditions[key]
      }
    })
  }
  return result
}

/**
 * Processes custom attributes before sending to the preview endpoint.
 * Strips subscription preferences if the feature is disabled,
 * or normalises null preference values to 'NULL' string if enabled.
 *
 * @param {Object|null} attributes
 * @returns {Object|null}
 */
export function processCustomAttributes(attributes) {
  if (!attributes || typeof attributes !== 'object') return attributes

  if (!$hasFeature('subscriptionPreferences')) {
    const filtered = {}
    Object.keys(attributes).forEach(key => {
      if (!key.includes('user.preferences')) {
        filtered[key] = attributes[key]
      }
    })
    return filtered
  }

  const processed = { ...attributes }
  Object.keys(processed).forEach(key => {
    if (key.includes('user.preferences') && processed[key] == null) {
      processed[key] = 'NULL'
    }
  })
  return processed
}



// WEBPACK FOOTER //
// ./src/modules/campaign-manage/helpers/PreviewAttributeHelper.js